module.exports = __webpack_public_path__ + "img/img2.b41f3438.jpg";